import { EventTrackingReq } from '@/api/interface/common';

// 功能：埋点上报 ，掉接口，函数参数：埋点名称，埋点参数，是否需要重复打印（默认不重复）
// name `${页面名称}_${事件名}_${l参数}`
export const report = (
  name: string,
  params: EventTrackingReq,
  repeat: boolean = false,
  serverSide: boolean = false,
) => {
  // 旧埋点已弃用，这里去除上报逻辑，什么也不做
};

// 判断 后端表单填错
export const formMessageIsErr = (msg: any) => {
  if (msg) {
    return /手机|格式|phone|mobile/.test(msg);
  }
  return false;
};
